module.exports = __webpack_public_path__ + "assets/img/signpost.5d1e3cd2.webp";